import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "bankInfo"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "goalInput" };
const _hoisted_4 = { key: 0 };
import { ref, nextTick, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useGoals } from '@/composables/useGoals';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import GoalInfoPanel from './elements/GoalInfoPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import AdButton from './elements/AdButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GoalsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo } = useBanking();
        const { getSavingGoals, clearSavingGoals, quoteSavingGoal, createSavingGoal } = useGoals();
        const drawer = ref(null);
        const savingsAccounts = ref(null);
        const selectedAccount = ref(null);
        const quote = ref(null);
        const quotation = ref(null);
        const defaultGoalFields = () => [
            {
                fields: [
                    { name: "name", label: "What are you saving for?", type: "text" },
                    { name: "targetAmount", label: "Target Amount", type: "currency" },
                    { name: "initial", label: "Initial contribution?", type: "currency" },
                    { name: "targetDate", label: "When do you want to reach your goal?", type: "datetext" },
                ]
            }
        ];
        const goalSections = ref(defaultGoalFields());
        function addGoal(account) {
            selectedAccount.value = account;
            nextTick(() => {
                drawer.value?.openDrawer();
            });
        }
        function onGoalSubmit() {
            // placeholder for InputSections submit
        }
        function quoteGoal() {
            var targetDate = goalSections.value[0].fields.find((f) => f.name == "targetDate")?.value;
            var goal = {
                bankAccountID: selectedAccount.value.id,
                "name": goalSections.value[0].fields.find((f) => f.name == "name")?.value,
                "targetAmount": goalSections.value[0].fields.find((f) => f.name == "targetAmount")?.value,
                "targetDate": targetDate.split('/').reverse().join('-'),
                "monthsRemaining": 0,
                "currentBalance": goalSections.value[0].fields.find((f) => f.name == "initial")?.value,
                "bankAccountName": selectedAccount.value.bank.prettyName,
                "instalmentAmount": 0.0,
                "archived": false
            };
            quoteSavingGoal(goal, (quoteResult) => {
                quote.value = quoteResult;
                quotation.value = quoteResult.goals.find((q) => q.id == '00000000-0000-0000-0000-000000000000');
            });
        }
        function createGoal(goal) {
            createSavingGoal(goal, () => {
                drawer.value?.closeDrawer();
                quote.value = null;
                quotation.value = null;
                goalSections.value = defaultGoalFields();
                clearSavingGoals();
                onLoad();
            });
        }
        async function onLoad() {
            getCustomer(() => {
                getBankingInfo(() => {
                    savingsAccounts.value = [];
                    state.bankInfo.accounts.forEach((a) => {
                        a.goals = [];
                        a.allocated = 0;
                        if (a.accountType.prettyName.toLowerCase() == "savings") {
                            savingsAccounts.value.push(a);
                        }
                    });
                    getSavingGoals(() => {
                        state.savingGoals.forEach((g) => {
                            var account = savingsAccounts.value.find((a) => a.id == g.bankAccountID);
                            account.allocated += g.currentBalance;
                            account.goals.push(g);
                        });
                    });
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Goals" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).bankInfo && _unref(state).savingGoals
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (savingsAccounts.value && savingsAccounts.value.length == 0)
                            ? (_openBlock(), _createBlock(AdButton, {
                                key: 0,
                                title: "Link Your Savings Accounts",
                                href: "/#/money?add=true",
                                subtitle: "Money Guided is designed to work with insights into your personal finances. Link your savings accounts to setup savings goals!",
                                topicon: require('@/assets/coins.png'),
                                bottomrighticon: require('@/assets/go.png')
                            }, null, 8, ["topicon", "bottomrighticon"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).bankInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(savingsAccounts.value, (a) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "well",
                                        key: a.id
                                    }, [
                                        _createElementVNode("h2", null, _toDisplayString(a.bank.prettyName) + " " + _toDisplayString(a.displayName), 1),
                                        _createVNode(_component_v_row, { class: "mt-2" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                        _createTextVNode(" Account balance: ")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(state).formatter.format(a.balance)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                        _createTextVNode(" Unallocated savings: ")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(state).formatter.format(a.balance - a.allocated)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024),
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-7" }, null, -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.goals, (g) => {
                                            return (_openBlock(), _createBlock(GoalInfoPanel, {
                                                small: true,
                                                href: '/#/Goals/' + g.id,
                                                class: "edged goalInfoPanel",
                                                key: g.id,
                                                title: g.name,
                                                goal: g.targetAmount,
                                                saved: g.currentBalance,
                                                instalment: g.instalmentAmount,
                                                formatter: _unref(state).formatter
                                            }, null, 8, ["href", "title", "goal", "saved", "instalment", "formatter"]));
                                        }), 128)),
                                        _createElementVNode("div", {
                                            class: "addButton",
                                            onClick: ($event) => (addGoal(a))
                                        }, " Create Goal ", 8, _hoisted_2)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (selectedAccount.value)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 0,
                        ref_key: "drawer",
                        ref: drawer,
                        closedHeight: 0,
                        bottom: 0,
                        title: 'Add Goal - ' + selectedAccount.value.bank.prettyName + ' ' + selectedAccount.value.displayName,
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(InputSections, {
                                    sections: goalSections.value,
                                    onSubmit: onGoalSubmit,
                                    theme: "light"
                                }, null, 8, ["sections"]),
                                (quotation.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Quote", -1)),
                                        _createElementVNode("p", null, "Instalment: " + _toDisplayString(_unref(state).formatter.format(quotation.value.instalmentAmount)), 1),
                                        _createElementVNode("p", null, _toDisplayString(quote.value.instalmentDescription), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createVNode(MGButton, {
                                    text: quotation.value ? 'Re-Quote' : 'Quote',
                                    onClick: quoteGoal
                                }, null, 8, ["text"]),
                                (quotation.value)
                                    ? (_openBlock(), _createBlock(MGButton, {
                                        key: 1,
                                        text: "Save",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (createGoal(quotation.value)))
                                    }))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }, 8, ["title"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
